/**
 * Client mirror of modules/inferWinnerFromGeneralHealth.js
 */

function resolvePlayerStateKey(gameState, playerId) {
  if (!gameState?.state || playerId == null) {
    return null;
  }
  if (gameState.state[playerId]) {
    return playerId;
  }
  const pid = String(playerId);
  return Object.keys(gameState.state).find((key) => String(key) === pid) ?? null;
}

function resolvePlayerIds(gameState) {
  if (Array.isArray(gameState.players) && gameState.players.length >= 2) {
    return gameState.players;
  }
  const stateKeys = Object.keys(gameState.state);
  if (stateKeys.length < 2) {
    return null;
  }
  return stateKeys;
}

/**
 * Best-effort winner inference for the client safety net (server sends the authoritative winner).
 * Returns null whenever the answer cannot be determined from the data (insufficient players,
 * missing/non-numeric health) — it must never throw and break a state merge.
 */
export function inferWinnerFromZeroGeneralHealth(gameState) {
  if (!gameState?.state || typeof gameState.state !== 'object') {
    return null;
  }

  const playerIds = resolvePlayerIds(gameState);
  if (!playerIds) {
    return null;
  }

  for (const playerId of playerIds) {
    const playerKey = resolvePlayerStateKey(gameState, playerId);
    if (!playerKey) {
      return null;
    }
    const player = gameState.state[playerKey];
    if (!player || typeof player !== 'object' || typeof player.health !== 'number') {
      return null;
    }
    if (player.health > 0) {
      continue;
    }
    const winnerId = playerIds.find((pid) => String(pid) !== String(playerId));
    if (winnerId == null) {
      return null;
    }
    return winnerId;
  }

  return null;
}
